module.exports = __webpack_public_path__ + "img/door_controller_masterlock.f38c7d76.png";